import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import useHovered from 'hooks/useHovered'

import ActionsDropdown, { TYPES } from '../../../components/ActionsDropdown/ActionsDropdown'

import loginIcon from './i/login.svg'

import './Page.scss'

const AuthPage = ({ methods, isSelected }) => {
    const { t } = useTranslation()

    const [isHovered, onMouseOver, onMouseLeave] = useHovered()

    return (
        <div
            className={classNames(
                'internal-pages__wrapper',
                'internal-pages__special-wrapper',
                'internal-pages__auth-wrapper',
            )}
        >
            <div
                onClick={() => methods.onSelect()}
                className={classNames('internal-pages__page', { 'is-select': isSelected })}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
            >
                <div className="internal-pages__page-label">{t('Login page')}</div>

                <div className="internal-pages__special-page__img">
                    <img src={loginIcon} alt="" />
                </div>

                <ActionsDropdown
                    type={TYPES.AUTH}
                    isVisible={isHovered || isSelected}
                    methods={{
                        onRemove: () => methods.onRemove(),
                    }}
                />
            </div>
        </div>
    )
}

export default AuthPage
